const func = $target => {
    var $content = $target.find('input'),
        $button = $target.find('[data-id="copy-btn"]'),
        $alert = $target.find('.alert-success');

    $button.on('click touch', function(e) {
		e.preventDefault();
        $content.select();
        document.execCommand('copy');
		$alert.removeClass('d-none');
    });
};

export default func;